import { Checkbox } from "@progress/kendo-react-inputs";
import React from "react";
import Images from "../../Assets/Images";

export class SearchMenu extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
    };
  }

  componentDidMount() {
    this.init();
  }
  init = () => {
    let existingFilter = this.props.existingFilter
      ? this.props.existingFilter
      : [];
    this.setState({ data: this.props.data, existingFilter: existingFilter });
  };
  filterValue = () => {
   

    let temparr = [];

    this.state.data.map((item) => {
      if (item.checked) {
        temparr.push(item.hashValue);
      }
    });

    let filter = [];
    temparr.map((item) => {
      if (item == "") {
        filter.push({
          field: this.props.column.field,
          operator: "contains",
          value: item,
        });
      } else {
        filter.push({
          field: this.props.column.field,
          operator: "contains",
          value: item,
        });
      }
    });
    let temp = {
      logic: "or",
      filters: filter,
    };
    let col=this.props.column.field;
    this.props.filterChangeV(temp,col);
    this.props.onCloseMenu();
  };
  clearFilter = () => {
    try {
      let exi = [];
      if (this.props.existingFilter) {
        let filterData = this.props.existingFilter;
        filterData.map((filter2) => {
          if (filter2.filters) {
            filter2.filters.map((innerFilter) => {
              if (innerFilter.field != this.props.column.field) {
                if(!exi.includes(filter2)){
                  exi.push(filter2);
                }
                
              }
            });
          } else {
            if (filter2.field != this.props.column.field) {
              if(!exi.includes(filter2)){
                exi.push(filter2);
              }
            }
          }
        });
      }
      
    //   this.props.onFilterChange(exi, null);
    this.props.clearFilter(exi);
      this.props.onCloseMenu();

      this.state.data.map((item) => {
        item["checked"] = false;
      });
    } catch (err) {
    
    }
  };

  handleChange = (e, item) => {
    this.state.data.find((v) => v.id == item.id).checked = e.value;
  };
  render() {
    return (
      <div style={{ padding: 10 }}>
        {/* <GridColumnMenuSort {...this.props} /> */}
        <br />
        <span  style={{color:'white'}}>
          <img src={Images.FILTERWHITE} width="12" alt="Filter" /> Filter
        </span>
        <div className="checkBoxWrapper"  style={{color:'white'}}>
          {this.state.data &&
            this.state.data.map((item, index) => (
              <div className="checkBoxCont">
               
                <Checkbox
                  label={item.name}
                  value={item.checked}
                  onChange={(e) => this.handleChange(e, item)}
                />
              </div>
            ))}
        </div>
        <br />
        <div className="filterBtnCont">
          <div className="btnBox">
            <button className="k-button" onClick={this.clearFilter}>
              Clear
            </button>
          </div>
          <div className="btnBox">
            <button className="k-button k-primary" onClick={this.filterValue}>
              Filter
            </button>
          </div>
        </div>
      </div>
    );
  }
}
